<template>
  <fragment>
    <div
      class="modal-body p-0"
      :id="`${id}--big-question`"
      :style="{ 'font-size': customFontSize }"
    >
      <div class="collapse collapse-column" ref="modalNote">
        <div class="collapse-column-left border-right">
          <slot name="note" :isShowNote="isShowNote">
            <Note
              :Question="SubQuestion"
              :Q="Question"
              :onNoteSaved="onNoteSaved"
              @close-note="closeNote"
              v-if="!ms_isDebug && notable && isShowNote"
            />
          </slot>
        </div>

        <div class="collapse-column-right d-flex flex-column overflow-hidden">
          <div
            class="big-exam highlight-container"
            :class="`layout-0${layout}`"
          >
            <div class="l-01">
              <header class="border-bottom">
                <div
                  class="bg-light px-3 justify-content-between align-items-center d-flex"
                  style="height: 50px"
                >
                  <strong>题干介绍</strong>
                  <div class="d-flex align-items-center">
                    <small class="text-secondary mr-3">布局显示:</small>
                    <div class="btn-group btn-group-sm">
                      <button
                        class="btn btn-light"
                        :class="{ active: layout == 3 }"
                        @click="setLayout(3)"
                      >
                        <i class="pz-icon icon-modal-layout-2 f-18"></i>
                      </button>
                      <button
                        class="btn btn-light"
                        :class="{ active: layout == 1 }"
                        @click="setLayout(1)"
                      >
                        <i class="pz-icon icon-modal-layout-1 f-18"></i>
                      </button>
                      <button
                        class="btn btn-light"
                        :class="{ active: layout == 2 }"
                        @click="setLayout(2)"
                      >
                        <i class="pz-icon icon-modal-layout-3 f-18"></i>
                      </button>
                      <button
                        class="btn btn-light"
                        :class="{ active: layout == 4 }"
                        @click="setLayout(4)"
                      >
                        <i class="pz-icon icon-modal-layout-4 f-18"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </header>
              <main class="card-body overflow-auto">
                <!-- <span>
                  <b>
                    <i>
                      No.PZ{{ Question.source }}
                      <template v-if="Question.rawTypeName">({{ Question.rawTypeName }})</template>
                    </i>
                  </b>
                </span>-->

                <div
                  class="d-flex justify-content-between align-items-center mb-4"
                >
                  <b>
                    No.PZ{{ Question.source }}
                    <template v-if="Question.rawTypeName"
                      >({{ Question.rawTypeName }})</template
                    >
                  </b>
                  <span class="small mr-n5 text-secondary"
                    >来源: {{ Question.questionFrom }}</span
                  >
                </div>

                <div class="mb-4" ref="casePopup">
                  <div
                    class="allow-select"
                    v-if="Question.detail"
                    v-html="Question.detail.imageQuestionHtml"
                    ref="largeHtml"
                  ></div>
                </div>
              </main>
            </div>
            <div class="l-02">
              <header class="border-bottom">
                <div
                  class="bg-light px-3 align-items-center d-flex"
                  style="height: 50px"
                >
                  <strong>题号:</strong>
                  <ul class="pagination-practice _number">
                    <li
                      class="pagination-item"
                      :key="`sub-questions-${subQ.questionId}`"
                      v-for="(subQ, i) in Question.subQuestions"
                      :class="{
                        _active: Question.pos === i,
                        _right:
                          subQ.isCorrect && subQ.isAnswered && !isTakingExam,
                        _wrong:
                          !subQ.isCorrect && subQ.isAnswered && !isTakingExam,
                        _answered: subQ.studentAnswer && isTakingExam,
                      }"
                      @click="onSetQuestion({ pos: i })"
                    >
                      {{ i + 1 }}
                    </li>
                  </ul>
                </div>
              </header>
              <main class="card-body overflow-auto">
                <!-- <span>
                  <b>
                    <i>
                      No.PZ{{ SubQuestion.source }}
                      <template v-if="Question.rawTypeName"
                        >({{ SubQuestion.rawTypeName }})</template
                      >
                    </i>
                  </b>
                </span>-->

                <div
                  class="d-flex justify-content-between align-items-center mb-4"
                >
                  <b>
                    No.PZ{{ SubQuestion.source }}
                    <template v-if="Question.rawTypeName"
                      >({{ SubQuestion.rawTypeName }})</template
                    >
                  </b>
                  <span class="small mr-n5 text-secondary"
                    >来源: {{ SubQuestion.questionFrom }}</span
                  >
                </div>

                <div class="mb-5" ref="allowSelect">
                  <div
                    class="allow-select"
                    v-if="SubQuestion.detail"
                    v-html="SubQuestion.detail.imageQuestionHtml"
                    ref="imageQuestionHtml"
                  ></div>
                </div>
                <template v-if="SubQuestion.detail">
                  <template v-if="c_isSubQuestionTypeOP">
                    <div
                      class="list-group list-group-flush border-bottom qa-option-list"
                      :class="{ checkbox: SubQuestion.noDefiniteQuestion }"
                    >
                      <h5 v-if="SubQuestion.isAnswered && !isTakingExam">
                        {{
                          c_isAnsweredBlank
                            ? '您没有作答该题, '
                            : `您的回答${
                                SubQuestion.selectedOption
                                  ? SubQuestion.selectedOption.toUpperCase()
                                  : SubQuestion.studentAnswer.toUpperCase()
                              }, `
                        }}正确答案是:
                        {{ SubQuestion.answer.toUpperCase() }}
                      </h5>
                      <div
                        class="list-group-item d-flex align-items-center media px-2"
                        v-show="SubQuestion.detail.imageOption0Html"
                      >
                        <span class="qa-option-level _empty-border"
                          >&nbsp;&nbsp;</span
                        >
                        <div class="media-body" ref="allowSelectOption0">
                          <span
                            class="qa-option-text font-weight-bold allow-select"
                            v-html="SubQuestion.detail.imageOption0Html"
                            ref="imageOption0Html"
                          ></span>
                        </div>
                      </div>

                      <div
                        @click.prevent="selectOption('A')"
                        :class="{
                          selected:
                            SubQuestion.selectedOption.indexOf('A') !== -1 ||
                            (SubQuestion.studentAnswer.indexOf('A') !== -1 &&
                              SubQuestion.selectedOption === '' &&
                              isTakingExam),
                          correct:
                            SubQuestion.selectedOption.indexOf('A') !== -1 &&
                            SubQuestion.answer.indexOf('A') !== -1 &&
                            SubQuestion.isAnswered &&
                            !isTakingExam,
                          incorrect:
                            ((!SubQuestion.noDefiniteQuestion &&
                              SubQuestion.selectedOption.indexOf('A') !== -1 &&
                              SubQuestion.answer.indexOf('A') === -1) ||
                              (SubQuestion.noDefiniteQuestion &&
                                ((SubQuestion.selectedOption.indexOf('A') !==
                                  -1 &&
                                  SubQuestion.answer.indexOf('A') === -1) ||
                                  (SubQuestion.answer.indexOf('A') !== -1 &&
                                    SubQuestion.selectedOption.indexOf('A') ===
                                      -1)))) &&
                            SubQuestion.isAnswered &&
                            !isTakingExam,
                          missed:
                            SubQuestion.noDefiniteQuestion &&
                            SubQuestion.answer.indexOf('A') !== -1 &&
                            SubQuestion.selectedOption.indexOf('A') === -1 &&
                            SubQuestion.isAnswered &&
                            !isTakingExam,
                        }"
                        class="list-group-item list-group-item-action d-flex align-items-center media px-2"
                        v-if="SubQuestion.detail.imageOptionaHtml"
                      >
                        <span class="qa-option-level">A</span>
                        <div class="media-body">
                          <small class="text-danger missed">未选择</small>
                          <small class="text-danger">不正确</small>
                          <small class="text-success">正确</small>
                          <span
                            class="qa-option-text"
                            v-html="`${SubQuestion.detail.imageOptionaHtml}`"
                          ></span>
                        </div>
                      </div>

                      <div
                        @click.prevent="selectOption('B')"
                        :class="{
                          selected:
                            SubQuestion.selectedOption.indexOf('B') !== -1 ||
                            (SubQuestion.studentAnswer.indexOf('B') !== -1 &&
                              SubQuestion.selectedOption === '' &&
                              isTakingExam),
                          correct:
                            SubQuestion.selectedOption.indexOf('B') !== -1 &&
                            SubQuestion.answer.indexOf('B') !== -1 &&
                            SubQuestion.isAnswered &&
                            !isTakingExam,
                          incorrect:
                            ((!SubQuestion.noDefiniteQuestion &&
                              SubQuestion.selectedOption.indexOf('B') !== -1 &&
                              SubQuestion.answer.indexOf('B') === -1) ||
                              (SubQuestion.noDefiniteQuestion &&
                                ((SubQuestion.selectedOption.indexOf('B') !==
                                  -1 &&
                                  SubQuestion.answer.indexOf('B') === -1) ||
                                  (SubQuestion.answer.indexOf('B') !== -1 &&
                                    SubQuestion.selectedOption.indexOf('B') ===
                                      -1)))) &&
                            SubQuestion.isAnswered &&
                            !isTakingExam,
                          missed:
                            SubQuestion.noDefiniteQuestion &&
                            SubQuestion.answer.indexOf('B') !== -1 &&
                            SubQuestion.selectedOption.indexOf('B') === -1 &&
                            SubQuestion.isAnswered &&
                            !isTakingExam,
                        }"
                        class="list-group-item list-group-item-action d-flex align-items-center media px-2"
                        v-if="SubQuestion.detail.imageOptionbHtml"
                      >
                        <span class="qa-option-level">B</span>
                        <div class="media-body">
                          <small class="text-danger missed">未选择</small>
                          <small class="text-danger">不正确</small>
                          <small class="text-success">正确</small>
                          <span
                            class="qa-option-text"
                            v-html="`${SubQuestion.detail.imageOptionbHtml}`"
                          ></span>
                        </div>
                      </div>

                      <div
                        @click.prevent="selectOption('C')"
                        :class="{
                          selected:
                            SubQuestion.selectedOption.indexOf('C') !== -1 ||
                            (SubQuestion.studentAnswer.indexOf('C') !== -1 &&
                              SubQuestion.selectedOption === '' &&
                              isTakingExam),
                          correct:
                            SubQuestion.selectedOption.indexOf('C') !== -1 &&
                            SubQuestion.answer.indexOf('C') !== -1 &&
                            SubQuestion.isAnswered &&
                            !isTakingExam,
                          incorrect:
                            ((!SubQuestion.noDefiniteQuestion &&
                              SubQuestion.selectedOption.indexOf('C') !== -1 &&
                              SubQuestion.answer.indexOf('C') === -1) ||
                              (SubQuestion.noDefiniteQuestion &&
                                ((SubQuestion.selectedOption.indexOf('C') !==
                                  -1 &&
                                  SubQuestion.answer.indexOf('C') === -1) ||
                                  (SubQuestion.answer.indexOf('C') !== -1 &&
                                    SubQuestion.selectedOption.indexOf('C') ===
                                      -1)))) &&
                            SubQuestion.isAnswered &&
                            !isTakingExam,
                          missed:
                            SubQuestion.noDefiniteQuestion &&
                            SubQuestion.answer.indexOf('C') !== -1 &&
                            SubQuestion.selectedOption.indexOf('C') === -1 &&
                            SubQuestion.isAnswered &&
                            !isTakingExam,
                        }"
                        class="list-group-item list-group-item-action d-flex align-items-center media px-2"
                        v-if="SubQuestion.detail.imageOptioncHtml"
                      >
                        <span class="qa-option-level">C</span>
                        <div class="media-body">
                          <small class="text-danger missed">未选择</small>
                          <small class="text-danger">不正确</small>
                          <small class="text-success">正确</small>
                          <span
                            class="qa-option-text"
                            v-html="`${SubQuestion.detail.imageOptioncHtml}`"
                          ></span>
                        </div>
                      </div>

                      <div
                        @click.prevent="selectOption('D')"
                        :class="{
                          selected:
                            SubQuestion.selectedOption.indexOf('D') !== -1 ||
                            (SubQuestion.studentAnswer.indexOf('D') !== -1 &&
                              SubQuestion.selectedOption === '' &&
                              isTakingExam),
                          correct:
                            SubQuestion.selectedOption.indexOf('D') !== -1 &&
                            SubQuestion.answer.indexOf('D') !== -1 &&
                            SubQuestion.isAnswered &&
                            !isTakingExam,
                          incorrect:
                            ((!SubQuestion.noDefiniteQuestion &&
                              SubQuestion.selectedOption.indexOf('D') !== -1 &&
                              SubQuestion.answer.indexOf('D') === -1) ||
                              (SubQuestion.noDefiniteQuestion &&
                                ((SubQuestion.selectedOption.indexOf('D') !==
                                  -1 &&
                                  SubQuestion.answer.indexOf('D') === -1) ||
                                  (SubQuestion.answer.indexOf('D') !== -1 &&
                                    SubQuestion.selectedOption.indexOf('D') ===
                                      -1)))) &&
                            SubQuestion.isAnswered &&
                            !isTakingExam,
                          missed:
                            SubQuestion.noDefiniteQuestion &&
                            SubQuestion.answer.indexOf('D') !== -1 &&
                            SubQuestion.selectedOption.indexOf('D') === -1 &&
                            SubQuestion.isAnswered &&
                            !isTakingExam,
                        }"
                        class="list-group-item list-group-item-action d-flex align-items-center media px-2"
                        v-if="SubQuestion.detail.imageOptiondHtml"
                      >
                        <span class="qa-option-level">D</span>
                        <div class="media-body">
                          <small class="text-danger missed">未选择</small>
                          <small class="text-danger">不正确</small>
                          <small class="text-success">正确</small>
                          <span
                            class="qa-option-text"
                            v-html="`${SubQuestion.detail.imageOptiondHtml}`"
                          ></span>
                        </div>
                      </div>

                      <div
                        @click.prevent="selectOption('E')"
                        :class="{
                          selected:
                            SubQuestion.selectedOption.indexOf('E') !== -1 ||
                            (SubQuestion.studentAnswer.indexOf('E') !== -1 &&
                              SubQuestion.selectedOption === '' &&
                              isTakingExam),
                          correct:
                            SubQuestion.selectedOption.indexOf('E') !== -1 &&
                            SubQuestion.answer.indexOf('E') !== -1 &&
                            SubQuestion.isAnswered &&
                            !isTakingExam,
                          incorrect:
                            ((!SubQuestion.noDefiniteQuestion &&
                              SubQuestion.selectedOption.indexOf('E') !== -1 &&
                              SubQuestion.answer.indexOf('E') === -1) ||
                              (SubQuestion.noDefiniteQuestion &&
                                ((SubQuestion.selectedOption.indexOf('E') !==
                                  -1 &&
                                  SubQuestion.answer.indexOf('E') === -1) ||
                                  (SubQuestion.answer.indexOf('E') !== -1 &&
                                    SubQuestion.selectedOption.indexOf('E') ===
                                      -1)))) &&
                            SubQuestion.isAnswered &&
                            !isTakingExam,
                          missed:
                            SubQuestion.noDefiniteQuestion &&
                            SubQuestion.answer.indexOf('E') !== -1 &&
                            SubQuestion.selectedOption.indexOf('E') === -1 &&
                            SubQuestion.isAnswered &&
                            !isTakingExam,
                        }"
                        class="list-group-item list-group-item-action d-flex align-items-center media px-2"
                        v-if="SubQuestion.detail.imageOptioneHtml"
                      >
                        <span class="qa-option-level">E</span>
                        <div class="media-body">
                          <small class="text-danger missed">未选择</small>
                          <small class="text-danger">不正确</small>
                          <small class="text-success">正确</small>
                          <span
                            class="qa-option-text"
                            v-html="`${SubQuestion.detail.imageOptioneHtml}`"
                          ></span>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-if="c_isSubQuestionTypeQA">
                    <div
                      class="border-bottom"
                      :class="{ checkbox: SubQuestion.noDefiniteQuestion }"
                    >
                      <h5
                        class="text-red"
                        v-if="SubQuestion.isAnswered && !isTakingExam"
                      >
                        {{
                          c_isAnsweredBlank
                            ? '您没有作答该题'
                            : '以下是您的回答'
                        }}
                      </h5>
                      <div class="d-flex align-items-center media px-2">
                        <div
                          class="media-body"
                          style="width: 100%"
                          v-if="!c_isAnsweredBlank"
                        >
                          <ckeditor
                            :editor="editor"
                            v-model="writtenText"
                            @input="writeAnswer"
                            :disabled="c_isEditorDisabled"
                            v-if="!c_isCpaQuestion"
                          ></ckeditor>
                          <sa-editor
                            v-model="writtenText"
                            @input="writeAnswer"
                            :disabled="c_isEditorDisabled"
                            v-if="c_isCpaQuestion"
                          />
                          <!-- <textarea
                            :readonly="c_isEditorDisabled"
                            v-model="writtenText"
                          ></textarea>-->
                          <p class="text-danger" v-if="c_isWrittenTextTooLong">
                            回答内容长度不能超过50000个有效字符。
                          </p>
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
                <div
                  class="mt-6"
                  v-if="SubQuestion.isAnswered && !isTakingExam"
                >
                  <h5>数据统计(全部)</h5>
                  <table class="table table-bordered bg-light">
                    <tbody>
                      <tr class="row no-gutters">
                        <td class="col-4 px-3">
                          做对次数:
                          <strong class="text-success">{{
                            SubQuestion.correctCount
                          }}</strong>
                        </td>
                        <td class="col-4 px-3">
                          做错次数:
                          <strong class="text-danger">{{
                            SubQuestion.wrongCount
                          }}</strong>
                        </td>
                        <td
                          class="col-4 px-3"
                          v-if="
                            SubQuestion.correctCount + SubQuestion.wrongCount >
                            0
                          "
                        >
                          正确率:
                          <strong class="text-info">
                            {{
                              SubQuestion.wrongCount +
                                SubQuestion.correctCount >
                              0
                                ? (
                                    (SubQuestion.correctCount /
                                      (SubQuestion.wrongCount +
                                        SubQuestion.correctCount)) *
                                    100
                                  ).toFixed(2)
                                : '0'
                            }}%
                          </strong>
                        </td>
                        <td class="col-4 px-3" v-else>
                          正确率:
                          <strong class="text-info">0%</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <h5 v-if="!isTakingExam">数据统计(个人)</h5>
                  <table
                    v-if="!isTakingExam"
                    class="table table-bordered bg-light"
                  >
                    <tbody>
                      <tr class="row no-gutters">
                        <td class="col-4 px-3">
                          做对次数:
                          <strong class="text-success">{{
                            SubQuestion.personalCorrectCount
                          }}</strong>
                        </td>
                        <td class="col-4 px-3">
                          做错次数:
                          <strong class="text-danger">{{
                            SubQuestion.personalWrongCount
                          }}</strong>
                        </td>
                        <td
                          class="col-4 px-3"
                          v-if="
                            SubQuestion.personalCorrectCount +
                              SubQuestion.personalWrongCount >
                            0
                          "
                        >
                          正确率:
                          <strong class="text-info">
                            {{
                              SubQuestion.personalWrongCount +
                                SubQuestion.personalCorrectCount >
                              0
                                ? (
                                    (SubQuestion.personalCorrectCount /
                                      (SubQuestion.personalWrongCount +
                                        SubQuestion.personalCorrectCount)) *
                                    100
                                  ).toFixed(2)
                                : '0'
                            }}%
                          </strong>
                        </td>
                        <td class="col-4 px-3" v-else>
                          正确率:
                          <strong class="text-info">0%</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <h5>解析</h5>
                  <span
                    v-if="
                      SubQuestion.detail.imageExplainHtml &&
                      SubQuestion.isAnswered
                    "
                    v-html="`${SubQuestion.detail.imageExplainHtml}`"
                  ></span>
                </div>
              </main>
            </div>

            <button
              ref="highlightSelectedBtn"
              class="highlight-btn highlight-mark-btn no-select"
              aria-hidden="true"
              role="alert"
            >
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAACjUlEQVRIS7WXS4hOYRjHf49bLqHkslEuS7dYyEJYWiBhQzEokgUp1waR6xgjioXJCjUWg4UFWSg7O5SahVjIQoki45bLX//p/XTMfN985xzfPOvzPr/3uf3f5wQDZJJmAWuB50BnRHzNomIguJIWAheBecBn4DTQFhHfK7yGgiXZ33LgAjA9E5SjPQWcrcAbBpY0BFgPtACTqmTyH3hDwJKGAzuAQ8CYfspn+Eng3H+DJRl0ENgJ+AL17ItL8V9gSRNT4zQBTnVe6y4NljQtNdEKoKifJ0UP9EQkaQ5wCViUN8TMd8+ArYXBkhYn6OwS0FfApoh4mBucZnQlcB6YWgL6DtgWEbd9Nhc4zejG1EgTSkC7gd3AlYhQLnCa0V1AMzC6BNQyeQxojYifuSQzRXoE2AcMKwH9lTS7OfcjIWkUMDi9MK3A2BLg6xaWiPjQ+2zVGksamUTdqd0PrLLAF4TfBbZExJtqF+4DljQIOAA4xUOBq8AeYHUB+COgKSJe1MpSNfB44AFgkbD9Bq4VgHcBGyLicX+lqQa25hq0LnMwL/w1sDkifPF+rVaN/bwd73WyHvw9sD0iOutBa86xJEMN72214BaIvUB7RSDqwaul2mN0C1ha43AWvgY4kWa1JSJ+1APWFBBJXl/aAY9ULTPcM+runwJ0RcSnvNA+qZa0DLgMTM7hxGuM57Qjx7d9PvmbakmG3QdmVHHkFHpNdce7FIZaULyyur6FLQv2/N4ElmS8WOCtQDeAl8AIYC7wFriT3ZOLknvAkqzD84GPqVEWpKjOpKgcbUMtEvSo65VWz3uAn8GnaTy+NZSYnBnsPbeymrYBh5NMKu9MlrmYwTMB/2CNAzoiwukecPsDyoHXlSxqMgkAAAAASUVORK5CYII="
                alt
              />
              <span class="sr-only">Highlight selected text</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer justify-content-between p-2 p-md-3">
      <!-- <div class="modal-footer-left"> -->
      <ul class="modal-footer-right list-inline">
        <li class="list-inline-item" v-if="notable">
          <button
            :class="{ active: SubQuestion.haveNote }"
            type="button"
            class="btn btn-link text-secondary btn-note collapsed"
            data-toggle="collapse"
            data-target=".collapse-column"
            aria-expanded="false"
            aria-controls="collapse-column"
            @click="toggleNote"
          >
            <i class="pz-icon icon-create"></i>
            <span class="d-none d-md-inline-block">笔记</span>
          </button>
        </li>
        <li class="list-inline-item" v-if="markable">
          <button
            type="button"
            class="btn btn-link text-secondary btn-bookmark"
            :class="{
              active: SubQuestion.isMarked,
            }"
            @click="onMark"
          >
            <i class="pz-icon icon-bookmark"></i>
            <span class="d-none d-md-inline-block">收藏</span>
          </button>
        </li>
        <li class="list-inline-item" v-if="isTakingExam">
          <button
            type="button"
            @click="submitPaper()"
            class="btn btn-link text-info d-flex"
          >
            <i class="pz-icon icon-description"></i>
            <span class="ml-2">交卷</span>
          </button>
        </li>
        <li class="list-inline-item">
          <button
            type="button"
            class="btn btn-link text-secondary d-flex"
            :class="p_isQuestionReported && 'text-muted disabled'"
            data-toggle="collapse"
            :data-target="p_isQuestionReported ? '' : '#pz-question-report'"
            aria-expanded="false"
            aria-controls="a-modal-pop"
          >
            <i class="pz-icon icon-error mr-1"></i>
            <span class="d-none d-md-inline-block">纠错</span>
          </button>
        </li>
        <!-- <li class="list-inline-item" v-if="exerciseType === 3">
          <button type="button" class="btn btn-link text-danger btn-bookmark">
            <i class="material-icons">delete_forever</i>
            <span class="d-none d-md-inline-block">删除</span>
          </button>
        </li>-->

        <!-- <li class="list-inline-item" v-if="isShowStepper && tips">{{ tips }}</li> -->
        <li class="list-inline-item small border-left pl-3" v-if="isTakingExam">
          <!-- <i class="pz-icon icon-clock text-muted mr-2"></i> -->
          <span class="text-secondary">考试剩余时间: {{ surplusTime }}</span>
        </li>
      </ul>
      <!-- </div> -->
      <!-- <div class="modal-footer-right"> -->
      <ul class="modal-footer-right list-inline">
        <li
          class="list-inline-item"
          v-if="isShowStepper && QuestionList.length <= 20"
        >
          <ul class="pagination-practice">
            <li
              class="pagination-item"
              v-for="(q, qIdx) in QuestionList"
              :key="`stepper-question-li-${qIdx}`"
              :class="{
                _right: q.questionStatus === 1,
                _wrong: q.questionStatus === -1,
                _active: q.questionId === Question.questionId,
              }"
            ></li>
          </ul>
        </li>
        <li v-if="isShowStepper" class="list-inline-item">
          {{ Position }}/{{ QuestionList.length }}
        </li>
        <li class="list-inline-item" v-if="isShowScantron">
          <button
            class="btn btn-link text-dark text-decoration-none d-flex"
            type="button"
            data-toggle="collapse"
            data-target="#pz-scantron"
            aria-expanded="false"
            aria-controls="a-sheet"
          >
            <i class="pz-icon icon-sheet mr-1"></i>
            <span class="ml-2">{{ Position }}/{{ QuestionList.length }}</span>
          </button>
        </li>
        <template v-if="isTakingExam">
          <li class="list-inline-item" v-if="!SubQuestion.isSubmitted">
            <button
              type="button"
              @click="answer()"
              :disabled="c_isAnswerBtnDisabled"
              class="btn btn-primary px-4"
            >
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                v-if="loading"
              ></span>
              提交
            </button>
          </li>
          <li
            class="list-inline-item"
            v-if="
              Question.isLatest &&
              SubQuestion.isSubmitted &&
              SubQuestion.isLatest
            "
          >
            <button
              type="button"
              @click="submitPaper()"
              :disabled="aopLoading"
              class="btn btn-primary px-4"
            >
              <span
                v-if="loading"
                :disabled="aopLoading"
                class="pe-7s-refresh pe-spin"
              ></span>
              交卷
            </button>
          </li>
        </template>
        <template v-if="!isTakingExam">
          <li class="list-inline-item" v-if="!SubQuestion.isSubmitted">
            <button
              type="button"
              @click="answer()"
              :disabled="c_isAnswerBtnDisabled"
              class="btn btn-primary px-4"
            >
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                v-if="loading"
              ></span>
              提交
            </button>
          </li>
          <li
            class="list-inline-item"
            v-if="SubQuestion.isSubmitted && !SubQuestion.isLatest"
          >
            <button
              type="button"
              class="btn btn-primary px-4"
              @click="goToNext()"
              :disabled="aopLoading"
            >
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                v-if="aopLoading"
              ></span
              >下一小题
            </button>
          </li>
          <li
            class="list-inline-item"
            v-if="
              SubQuestion.isSubmitted &&
              SubQuestion.isLatest &&
              !Question.isLatest
            "
          >
            <button
              type="button"
              class="btn btn-primary px-4"
              @click="goToNext()"
              :disabled="aopLoading"
            >
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                v-if="aopLoading"
              ></span
              >下一大题
            </button>
          </li>
          <li
            class="list-inline-item"
            v-if="
              Question.isLatest &&
              SubQuestion.isSubmitted &&
              SubQuestion.isLatest
            "
          >
            <button
              type="button"
              @click="onClose()"
              class="btn btn-primary px-4"
              :disabled="aopLoading"
            >
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                v-if="aopLoading"
              ></span>
              结束
            </button>
          </li>
        </template>
      </ul>
    </div>
  </fragment>
</template>
<script>
import $ from 'jquery';
import Swal from 'sweetalert2';
import { mapState, mapGetters } from 'vuex';
import rangy from 'rangy';
import 'rangy/lib/rangy-classapplier';

import * as constants from '@/constants';
import { mapStringToKatex } from '../../utils';
import Note from './Note.vue';

export default {
  name: 'Big',

  components: {
    Note,
    'sa-editor': () => import('@/components/SaEditor.vue'),
  },

  props: {
    id: String,
    questionFontSize: Number,
    QuestionList: {
      type: Array,
      default: () => [],
    },

    qaStatus: Boolean,

    isTakingExam: {
      type: Boolean,
      default: () => false,
    },

    p_isQuestionReported: {
      type: Boolean,
      default: () => false,
    },

    Question: Object,

    notable: {
      type: Boolean,
      default: () => false,
    },

    markable: {
      type: Boolean,
      default: () => false,
    },

    isShowScantron: {
      type: Boolean,
      default: () => false,
    },

    onAnswer: {
      type: Function,
      default: () => {},
    },

    onMark: {
      type: Function,
      default: () => {},
    },

    onGoToNext: {
      type: Function,
      default: () => {},
    },

    onClose: {
      type: Function,
      default: () => {},
    },

    Position: {
      type: Number,
      default: () => 0,
    },

    isShowStepper: {
      type: Boolean,
      default: () => false,
    },

    onSetQuestion: {
      type: Function,
      default: () => {},
    },

    surplusTime: {
      type: String,
      default: () => 0,
    },

    onGetAfterData: {
      type: Function,
      default: () => {},
    },

    isReadOnly: {
      type: Boolean,
      default: () => false,
    },

    onNoteSaved: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      pos: 0,
      layout: 2,
      writtenText: '',
      editor: window.ClassicEditor,
      isShowNote: false,

      applier: null,
    };
  },

  computed: {
    ...mapState({
      ms_isDebug: 'isDebug',
    }),

    ...mapGetters({
      aopLoading: 'aopLoading',
      loading: 'loading',
    }),

    SubQuestion: function () {
      return this.Question.subQuestions[this.Question.pos];
    },

    customFontSize: function () {
      let size = '1rem';
      switch (this.questionFontSize) {
        case 1:
          size = '1rem';
          break;
        case 2:
          size = '1.25rem';
          break;
        case 3:
          size = '1.5rem';
          break;
        default:
          size = '1rem';
      }
      return size;
    },

    c_isInEvent() {
      return constants.EVENTS_PAGE_CHUNK_NAME === this.$route.name;
    },

    c_isCpaQuestion() {
      if (this.SubQuestion.detail && this.SubQuestion.detail.questionRawType) {
        return this.SubQuestion.detail.questionRawType.indexOf('CPA') > -1;
      } else {
        return false;
      }
    },

    c_isSubQuestionTypeOP() {
      if (this.SubQuestion && this.SubQuestion.questionType) {
        return this.SubQuestion.questionType.indexOf('OP') !== -1;
      }
      return false;
    },

    c_isSubQuestionTypeQA() {
      if (this.SubQuestion && this.SubQuestion.questionType) {
        return this.SubQuestion.questionType.indexOf('QA') !== -1;
      }
      return false;
    },

    c_isNotSelectedOptionInOP() {
      return this.c_isSubQuestionTypeOP && !this.SubQuestion.selectedOption;
    },

    c_isSubQuestionTypeQAinEvent() {
      return this.c_isSubQuestionTypeQA && this.c_isInEvent;
    },

    c_isAnsweredBlank() {
      return (
        this.SubQuestion.isAnswered &&
        !this.SubQuestion.studentAnswer &&
        !this.SubQuestion.selectedOption
      );
    },

    c_isEditorDisabled() {
      if (this.c_isInEvent) {
        return !this.isTakingExam;
      } else {
        return this.SubQuestion.isAnswered;
      }
    },

    c_isWrittenTextTooLong() {
      if (this.writtenText && this.writtenText.length > 50000) {
        return true;
      } else {
        return false;
      }
    },

    c_isAnswerBtnDisabled() {
      return (
        this.c_isNotSelectedOptionInOP ||
        this.aopLoading ||
        this.isReadOnly ||
        this.c_isWrittenTextTooLong
      );
    },
  },

  watch: {
    Question: function (v1, v2) {
      if (v1.questionId !== v2.questionId) {
        mapStringToKatex();
      }
    },

    SubQuestion: function (v1, v2) {
      if (v1.questionId !== v2.questionId) {
        this.setWrittenTextFromStudentAnswer(v1);
        this.consoleLogAnswer(v1.answer);
      }
    },
  },

  methods: {
    selectOption(selectedOption) {
      if (this.isReadOnly) {
        return;
      }
      if (!this.SubQuestion.isAnswered || this.isTakingExam) {
        this.onSetQuestion({ selectedOption });
      }
    },

    writeAnswer() {
      if (this.isReadOnly) {
        return;
      }
      if (!this.SubQuestion.isAnswered || this.isTakingExam) {
        this.onSetQuestion({ selectedOption: this.writtenText });
      }
    },

    setWrittenTextFromStudentAnswer(subQuestion) {
      if (subQuestion.selectedOption) {
        this.writtenText = subQuestion.selectedOption;
      } else {
        if (subQuestion.studentAnswer && !this.isTakingExam) {
          this.writtenText = subQuestion.studentAnswer;
        } else {
          this.writtenText = '';
        }
      }
    },

    setLayout(layout) {
      this.layout = layout;
    },

    async answer() {
      if (this.SubQuestion.isAnswered && !this.c_isSubQuestionTypeQAinEvent) {
        return;
      }
      await this.onAnswer({
        studentAnswer: this.writtenText,
      });
      if (this.isTakingExam) {
        if (!this.SubQuestion.isLatest) {
          this.onSetQuestion({ pos: this.Question.pos + 1 });
        } else {
          this.onGoToNext();
        }
      } else {
        mapStringToKatex();
      }
    },

    goToNext() {
      if (!this.SubQuestion.isLatest) {
        this.onSetQuestion({ pos: this.Question.pos + 1 });
      } else {
        this.onGoToNext();
      }
    },

    submitPaper() {
      const _this = this;
      const undo = _this.QuestionList.filter((v) => v.questionStatus === 0);
      if (undo.length) {
        Swal.fire({
          title: '确定交卷吗？',
          text: `您还有${undo.length}道题没完成`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: '确定交卷',
          cancelButtonText: '继续考试',
        }).then((result) => {
          if (result.value) {
            _this.onGetAfterData();
          }
        });
      } else {
        Swal.fire({
          title: '确定交卷吗？',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: '确定交卷',
          cancelButtonText: '再检查一遍',
        }).then((result) => {
          if (result.value) {
            _this.onGetAfterData();
          }
        });
      }
    },

    toggleNote() {
      this.isShowNote = !this.isShowNote;
    },

    closeNote() {
      $(this.$refs.modalNote).collapse('hide');
      this.isShowNote = false;
    },

    consoleLogAnswer(answer) {
      if (console && this.ms_isDebug) {
        //console.clear();
        console.log('answer:', answer, '...', new Date());
      }
    },
  },

  created() {
    this.setWrittenTextFromStudentAnswer(this.SubQuestion);
  },

  mounted() {
    rangy.init();
    this.applier = rangy.createClassApplier('question-mark', {
      elementTagName: 'mark',
    });

    const allowSelectZone = this.$refs.allowSelect;
    const allowSelectOption0 = this.$refs.allowSelectOption0;
    const casePopup = this.$refs.casePopup;

    const highlightSelectedBtn = this.$refs.highlightSelectedBtn;
    highlightSelectedBtn.onmousedown = () => {
      this.applier.toggleSelection();
      window.getSelection().removeAllRanges();
      // this.applier.undoToSelection();
      highlightSelectedBtn.style.display = 'none';
      this.$emit('save-question-rangy-mark', {
        imageQuestionHtml: this.$refs.imageQuestionHtml.innerHTML,
        imageOption0Html: this.$refs.imageOption0Html
          ? this.$refs.imageOption0Html.innerHTML
          : undefined,
        largeHtml: this.$refs.largeHtml.innerHTML
          ? this.$refs.largeHtml.innerHTML
          : undefined,
        isCurrentQuestionXL: true,
        currentQuestionId: this.Question.questionId,
        currentSubQuestionIdx: this.Question.pos,
      });
    };

    const bindSelect = (allowSelectZone) => {
      if (!allowSelectZone) {
        return;
      }
      allowSelectZone.onmousedown = (e1) => {
        const xy1 = e1.pageX + e1.pageY;
        let xy2 = null;
        document.onmousemove = (e2) => {
          xy2 = e2.pageX + e2.pageY;
        };
        allowSelectZone.onmouseup = (e3) => {
          // console.log(window.getSelection());
          if (xy2 && xy1 != xy2 && !window.getSelection().isCollapsed) {
            highlightSelectedBtn.style.top = e3.layerY + 'px';
            highlightSelectedBtn.style.left = e3.layerX + 'px';
            highlightSelectedBtn.style.display = 'inline-block';
          } else {
            highlightSelectedBtn.style.display = 'none';
          }
          allowSelectZone.onmouseup = null;
          document.onmousemove = null;
        };
      };
    };
    bindSelect(allowSelectZone);
    bindSelect(allowSelectOption0);
    bindSelect(casePopup);

    this.consoleLogAnswer(this.SubQuestion.answer);
  },
};
</script>

<style lang="scss" scoped>
.ck-content {
  height: 300px !important;
}
.qa-option-list {
  .incorrect {
    .text-danger.missed {
      display: none;
    }
  }
  .missed {
    .text-danger {
      display: none;
    }
    .text-danger.missed {
      display: inline-block;
    }
  }
}

.allow-select,
.allow-select * {
  -khtml-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  -webkit-touch-callout: text;
  -webkit-user-select: text;
  cursor: default;
}
button.highlight-btn {
  background: #2b9ed8;
  border: 1px solid #2b9ed8;
  border-radius: 4px;
  color: #fff;
  display: inline-block;
  font-family: FontAwesome, Open Sans, Source Sans Pro, sans-serif;
  font-weight: 600;
  height: 44px;
  line-height: 44px;
  overflow: visible;
  padding: 0px;
  z-index: 1000;
  width: 44px;
}

button.highlight-btn {
  -moz-box-shadow: 2px 2px 4px 0px rgba(51, 51, 51, 0.5);
  -webkit-box-shadow: 2px 2px 4px 0px rgba(51, 51, 51, 0.5);
  box-shadow: 2px 2px 4px 0px rgba(51, 51, 51, 0.5);
  display: none;
  position: absolute;
}

button.highlight-btn::after {
  border: solid transparent;
  border-bottom-color: #2b9ed8;
  border-color: rgba(43, 158, 216, 0);
  border-width: 10px;
  bottom: 100%;
  content: ' ';
  height: 0;
  left: 50%;
  margin-left: -10px;
  pointer-events: none;
  position: absolute;
  width: 0;
}

button.highlight-btn img {
  height: 30px;
  padding: 5px;
  width: 30px;
}

.highlight-container {
  position: relative;
}
</style>
